export default {
  variId: [{
    required: true,
    message: '品种不能为空',
    trigger: 'blur'
  }],
  begin: [{
    required: true,
    message: '起始日期不能为空',
    trigger: 'blur'
  }, ],
  endTime: [{
    required: true,
    message: '上市日期不能为空',
    trigger: 'blur'
  }, ],
  scheId: [{
    required: true,
    message: '种植方案不能为空',
    trigger: 'blur'
  }, ],
}



// WEBPACK FOOTER //
// ./src/components/product/plan/plan-detail-rules.js